import { faFilter } from '@fortawesome/pro-solid-svg-icons';

import { IconButton } from 'atoms/buttons/IconButton';

type Props = { onClick: () => void };

export const FilterIconButton = ({ onClick }: Props) => {
  return (
    <IconButton
      onClick={onClick}
      small
      color="tertiary"
      disableDebounce
      icon={faFilter}
    />
  );
};
